import React, { Component } from 'react';
import Home from './components/Home';
import './custom.css';

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      //<Layout>
      //  <Routes>
      //    {AppRoutes.map((route, index) => {
      //      const { element, ...rest } = route;
      //      return <Route key={index} {...rest} element={element} />;
      //    })}
      //  </Routes>
      //</Layout>
      <Home/>
    );
  }
}
